import React, { memo, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, FormLabel, Tooltip, Grid, Typography } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import ErrorIcon from '@material-ui/icons/Error';
import { useLang } from '../../../util/lang';

const MERGED_OPTIONS = [
    { value: 'option.no', labelKey: '@PatientInfo.smileDesign.prescriptionNotes.option.preRestorativeAlignerNo' },
    {
        value: 'option.yes_14step',
        labelKey: '@PatientInfo.smileDesign.prescriptionNotes.option.preRestorativeAligner14Step',
    },
    {
        value: 'option.yes_unlimited',
        labelKey: '@PatientInfo.smileDesign.prescriptionNotes.option.preRestorativeAlignerUnlimited',
    },
];

const getMergedValue = (pre, upgrade) => {
    if (pre === 'option.no') return 'option.no';
    if (pre === 'option.yes' && upgrade === 'option.no') return 'option.yes_14step';
    if (pre === 'option.yes' && upgrade === 'option.yes') return 'option.yes_unlimited';
    return '';
};

// Renders the pre-restorative aligner simulation options.
const MergedPreRestorativeAlignerRhf = ({ question, readOnly = false, alwaysShowRequired = false }) => {
    const getLang = useLang();
    const { setValue, watch, formState, trigger, getValues } = useFormContext();

    const preValue = watch('preRestorativeAlignerSimulation');
    const upgradeValue = watch('upgradePreRestorativeAlignerSimulation');
    const mergedValue = getMergedValue(preValue, upgradeValue);

    useEffect(() => {
        if (!getValues('preRestorativeAlignerSimulation')) {
            setValue('preRestorativeAlignerSimulation', '', { shouldValidate: false });
        }
    }, []);

    const handleChange = (value) => {
        if (value === 'option.no') {
            setValue('preRestorativeAlignerSimulation', 'option.no', { shouldValidate: true });
            setValue('upgradePreRestorativeAlignerSimulation', 'option.no', { shouldValidate: true });
        } else if (value === 'option.yes_14step') {
            setValue('preRestorativeAlignerSimulation', 'option.yes', { shouldValidate: true });
            setValue('upgradePreRestorativeAlignerSimulation', 'option.no', { shouldValidate: true });
        } else if (value === 'option.yes_unlimited') {
            setValue('preRestorativeAlignerSimulation', 'option.yes', { shouldValidate: true });
            setValue('upgradePreRestorativeAlignerSimulation', 'option.yes', { shouldValidate: true });
        }
        setTimeout(() => {
            trigger('upgradePreRestorativeAlignerSimulation');
        }, 0);
    };

    if (readOnly) {
        const selected = MERGED_OPTIONS.find((opt) => opt.value === mergedValue);
        return (
            <div style={{ marginBottom: 20 }}>
                <div>{question}</div>
                <div style={{ marginLeft: 16, marginTop: 8 }}>
                    <Typography>{selected ? getLang(selected.labelKey) : ''}</Typography>
                </div>
            </div>
        );
    }

    return (
        <div style={{ marginBottom: 20 }}>
            <FormLabel component="legend" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: 8 }}>{question}</span>
                {alwaysShowRequired ? (
                    <span style={{ color: 'red' }}>*</span>
                ) : (
                    <ErrorMessage
                        errors={formState.errors}
                        name="preRestorativeAlignerSimulation"
                        render={({ message }) => (
                            <Tooltip title={getLang(message)}>
                                <span style={{ color: 'red' }}>*</span>
                            </Tooltip>
                        )}
                    />
                )}
            </FormLabel>
            <RadioGroup value={mergedValue} onChange={(e) => handleChange(e.target.value)}>
                <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
                    {MERGED_OPTIONS.map((opt) => (
                        <Grid item key={opt.value}>
                            <FormControlLabel
                                value={opt.value}
                                control={<Radio />}
                                label={<Typography>{getLang(opt.labelKey)}</Typography>}
                            />
                        </Grid>
                    ))}
                </Grid>
            </RadioGroup>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 6, fontStyle: 'italic' }}>
                {getLang('@PatientInfo.smileDesign.prescriptionNotes.note.preRestorativeAlignerSimulation')}
            </Typography>
            {/* {mergedValue === 'option.no' && (
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 6, fontStyle: 'italic' }}>
                    {getLang('@PatientInfo.smileDesign.prescriptionNotes.question.preRestorativeAlignerSimulationRemark')}
                </Typography>
            )} */}
        </div>
    );
};

export default memo(MergedPreRestorativeAlignerRhf);
